import React, { useState, useEffect } from 'react';
import FilterContainer from './FilterContainer';
import DropdownContainer from './DropdownContainer';

function FilterAccordionSingleSelect(props) {
  const {
    taxonomy,
    taxSlug,
    selected,
    displayPostCounts,
    label,
    collapsible,
    scrollable,
    dropdown,
    labelTitle,
    replaceSelected,
    isSelected,
    tooltip,
    tooltipLeftContent,
    tooltipRightContent
  } = props;

  const [closeRequest, setCloseRequest] = useState(false);
  const allTerms = [];
  const filterId = taxSlug ? `filter-${taxSlug}` : '';

  let parentContent;
  let childContent;
  let filterContent;

  function clickHandler(e, object) {
    e.preventDefault();
    replaceSelected(object.id, taxSlug);
  }

  function activeButtonClass(id) {
    let classString = '';

    if(isSelected(id, taxSlug)) {
      classString = 'active';
    }

    return classString;
  }

  if (taxonomy) {
    // pretty hacky :( but it is not respecting name or order set in functions.php
    if ('custom_meta_availability' === taxonomy[0].taxonomy) {
      let sortingArr = ['open', 'limited', 'closed'];
      taxonomy.sort(function(a, b){  
        return sortingArr.indexOf(a.value) - sortingArr.indexOf(b.value);
      });
    }
    taxonomy.forEach(term => {
      if ('custom_meta_availability' === term.taxonomy) {
        if (term.name === 'open') {
          term.name = 'Available';
        }
        if (term.name === 'limited') {
          term.name = 'Close to Full';
        }
        if (term.name === 'closed') {
          term.name = 'Full';
        }
      }
      // end hackyness
      if (displayPostCounts) {
        parentContent = `${term.name} (${term.count})`;
      }
      else {
        parentContent = term.name;
      }

      allTerms.push(
        <li className="parent-term" key={term.id}>
          <button 
            id={`${taxSlug}-${term.id}`}
            onClick={(e) => {clickHandler(e, term), setCloseRequest(true)}}
            className={activeButtonClass(term.id)}
          >
            <span dangerouslySetInnerHTML={{ __html: parentContent }}></span>
          </button>
        </li>
      )

      if (term.children) {
        term.children.forEach(child => {
          if (displayPostCounts) {
            childContent = `${child.name} (${child.count})`;
          }
          else {
            childContent = child.name;
          }

          allTerms.push(
            <li className="child-term" key={child.id}>
              <button 
                id={`${taxSlug}-${child.id}`}
                onClick={(e) => {clickHandler(e, child), setCloseRequest(true)}}
                className={activeButtonClass(child.id)}
              >
                <span dangerouslySetInnerHTML={{ __html: childContent }}></span>
              </button>
            </li>
          )
        });
      }
    });
  }

  if (dropdown) {
    filterContent = <DropdownContainer
      selected={selected}
      taxSlug={taxSlug} 
      taxonomy={taxonomy}
      closeRequest={closeRequest}
      setCloseRequest={setCloseRequest}
      defaultLabel={label} 
      labelTitle={labelTitle}
      >
        <ul className="dropdown-list">
          {allTerms}
        </ul>
      </DropdownContainer>
  }
  else {
    filterContent = <ul>
      {allTerms}
    </ul>
  }

  return (
    <FilterContainer 
    className="filter-accordion-single-select"
    label={label}
    filterId={filterId}
    collapsible={collapsible}
    scrollable={scrollable}
    tooltip={tooltip}
    tooltipLeftContent={tooltipLeftContent}
    tooltipRightContent={tooltipRightContent}
    labelTitle={labelTitle}
    >
      {filterContent}
    </FilterContainer>
  )
}

export default FilterAccordionSingleSelect;